import { c as _c } from "react/compiler-runtime";
import { Money } from "./Money";
interface CompareAtPriceProps {
  /** The reference (non-discounted) price. */
  originalPrice?: number | null;
  /** The selling price. When less than `originalPrice`, the strikethrough is shown. */
  discountPrice?: number | null;
  market?: string;
  /** Classes for the wrapping element. */
  className?: string;
  /** Classes for the strikethrough <Money>. */
  originalClassName?: string;
  /** Classes for the selling-price <Money>. */
  saleClassName?: string;
  /** Optional content rendered after the prices (e.g. a discount tag, savings %). */
  children?: React.ReactNode;
}

/**
 * Returns true when the discount price is a real markdown below the original price.
 * Use as a single source of truth for "should the line-through be visible?".
 */
export const hasRealDiscount = (originalPrice?: number | null, discountPrice?: number | null): originalPrice is number => {
  return typeof originalPrice === "number" && typeof discountPrice === "number" && discountPrice > 0 && discountPrice < originalPrice;
};

/**
 * Renders a compare-at + selling price pair. When there is no real discount, the
 * strikethrough original is hidden and only the selling price is shown — preventing
 * the bug where two identical values appear with one crossed out.
 */
export const CompareAtPrice = t0 => {
  const $ = _c(18);
  const {
    originalPrice,
    discountPrice,
    market,
    className,
    originalClassName,
    saleClassName,
    children
  } = t0;
  let t1;
  if ($[0] !== discountPrice || $[1] !== originalPrice) {
    t1 = hasRealDiscount(originalPrice, discountPrice);
    $[0] = discountPrice;
    $[1] = originalPrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const discounted = t1;
  const displayValue = discounted ? discountPrice : originalPrice ?? discountPrice;
  let t2;
  if ($[3] !== discounted || $[4] !== market || $[5] !== originalClassName || $[6] !== originalPrice) {
    t2 = discounted && <Money value={originalPrice} market={market} srLabel="Original price" className={originalClassName} />;
    $[3] = discounted;
    $[4] = market;
    $[5] = originalClassName;
    $[6] = originalPrice;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = discounted ? "Sale price" : "Price";
  let t4;
  if ($[8] !== displayValue || $[9] !== market || $[10] !== saleClassName || $[11] !== t3) {
    t4 = <Money value={displayValue} market={market} srLabel={t3} className={saleClassName} />;
    $[8] = displayValue;
    $[9] = market;
    $[10] = saleClassName;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== children || $[14] !== className || $[15] !== t2 || $[16] !== t4) {
    t5 = <span className={className}>{t2}{t4}{children}</span>;
    $[13] = children;
    $[14] = className;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};